<template>
  <RfColorTag
    v-if="getComputedData"
    :class="getComputedData.class"
    class="shrink-0"
    pill
    disabled
    :title="getComputedData.text"
  />
</template>

<script setup>
import RfColorTag from "@/components/tags/RfColorTag.vue";
import { computed } from "vue";

const props = defineProps({
  date: { type: Date, default: new Date() },
  isExpired: { type: Boolean, default: false },
  isLimited: { type: Boolean, default: false },
});

const getComputedData = computed(() => {
  try {
    const amountOfDaysFromToday = Math.floor((new Date() - props.date) / (24 * 3600 * 1000));

    if (props.isLimited)
      return { class: "rf-date-tag--limited bg-orange-2! text-orange-1", text: "Limited" };

    const expiresSoon = amountOfDaysFromToday >= -6 && amountOfDaysFromToday < 0;
    if (expiresSoon)
      return {
        class: "rf-date-tag--expiring-soon bg-orange-2! text-orange-1",
        text: "Expiring soon",
      };

    const isExpired = amountOfDaysFromToday >= -1;
    if (isExpired || props.isExpired)
      return {
        class: "rf-date-tag--expired bg-white-2! text-grey-3",
        text: "Expired",
      };

    return null;
  } catch (_e) {
    return null;
  }
});
</script>

<style lang="scss" scoped>
.rf-date-tag--limited {
  filter: hue-rotate(310deg);
}
</style>
